import { theme } from 'modules/ui';
import styled from 'styled-components';

export const RedAsteriskWrapper = styled.span`
  color: ${({theme}) => theme.colors.primaryR5};
  padding: 0.215rem;
`;
